import { fbEvent } from "@rivercode/facebook-conversion-api-nextjs";
import { ICheckout } from "@the-volte/svc-core-sdk/lib/api/Checkout/types";
import { ProductDetails } from "@the-volte/svc-core-sdk/lib/fragments/gqlTypes/ProductDetails";
import { User } from "@the-volte/svc-core-sdk/lib/fragments/gqlTypes/User";
import {
  ICheckoutModelLine,
  ICheckoutModelPrice,
} from "@the-volte/svc-core-sdk/lib/helpers";

enum Event {
  ViewContent = "ViewContent",
  AddToCart = "AddToCart",
  Purchase = "Purchase",
  InitiateCheckout = "InitiateCheckout ",
}

export const sendFacebookViewContentEvent = (
  product: ProductDetails,
  user?: User | null
) => {
  try {
    if (product) {
      fbEvent({
        eventName: Event.ViewContent,
        // eventId: 'eventId', // optional, unique event id's will be generated by default
        emails: user ? [user.email] : [], // optional
        // phones: ['phone1', 'phone2'], // optional
        products: product?.variants?.map((pv) => ({
          sku: pv?.sku || "",
          quantity: 1,
        })),
        value: product?.pricing?.priceRange?.start?.gross?.amount || 0,
        currency: product?.pricing?.priceRange?.start?.gross?.currency || "AUD",
        enableStandardPixel: true,
      });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
};

export const sendFacebookAddToCartEvent = (
  product: ProductDetails,
  variantId: string,
  user?: User | null
) => {
  try {
    if (product) {
      const variant = product?.variants?.find((pv) => pv?.id === variantId);
      const eventData = {
        eventName: Event.AddToCart,
        // eventId: 'eventId', // optional, unique event id's will be generated by default
        emails: user ? [user.email] : [], // optional
        // phones: ['phone1', 'phone2'], // optional
        products: [{ sku: variant?.sku, quantity: 1 }],
        value: variant?.pricing?.price?.gross?.amount || 0,
        currency: variant?.pricing?.price?.gross?.currency,
        enableStandardPixel: true,
      };
      fbEvent(eventData);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
};

export const sendFacebookPurchaseEvent = (
  items: ICheckoutModelLine[],
  totalPrice: ICheckoutModelPrice,
  checkout: ICheckout | undefined
) => {
  try {
    if (items.length) {
      const eventData = {
        eventName: Event.Purchase,
        // eventId: 'eventId', // optional, unique event id's will be generated by default
        emails: checkout?.email ? [checkout.email] : [], // optional
        // phones: ['phone1', 'phone2'], // optional
        products: items.map((i) => ({
          sku: i.variant.sku,
          quantity: i.quantity,
        })),
        value: totalPrice.gross.amount,
        currency: totalPrice.gross.currency,
        enableStandardPixel: true,
      };
      fbEvent(eventData);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
};
